export default "__VITE_ASSET__adb7a066__"